import React, { useState } from 'react';
import { Error } from 'components/message/Error';
import { uploadFile } from 'services/api/common';
import { showError } from 'utils/notifications';
import { readFileAsBase64 } from 'utils';
import { FilePreviewerThumbnail } from 'react-file-previewer-v2';
import FileUploaderWithPDF from './FileUploaderPDF';
import ActionButton from 'components/ActionButton';

const DocumentUpload = (props) => {
  const { onDocumentChange } = props;
  const [file, setFile] = useState<any>();
  const [url, setURL] = useState('');
  const [base64, setBase64] = useState('');
  const [error, setError] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [showUploadButton, setShowUploadButton] = useState(true);

  const onSelectFile = async (urlObject, file) => {
    if (file) {
      const base64: any = await readFileAsBase64(file);
      setBase64(base64);
    }
    setURL(urlObject);
    setFile(file);
  };

  const onError = (error) => {
    setError(error.toString());
  };

  const uploadDocument = async () => {
    try {
      setLoading(true);
      const media = await uploadFile(base64, file.type);
      setShowUploadButton(false);
      setLoading(false);
      onDocumentChange && onDocumentChange(media);
      clearFile();
    } catch (e) {
      setLoading(false);
      setError(e?.message || e);
      showError(e?.message || e);
    }
  };

  const clearFile = () => {
    setURL('');
    setError(null);
    setFile(null);
  };


  const getSelectedImageSlot = () => {
    return <>
      <div className="uploaded-image">
        {url && <FilePreviewerThumbnail
          file={url}
          onClick={() => console.log('Heej')}
        />}
      </div>
      {showUploadButton && (
        <div className="mt-2 d-flex justify-content-center upload-button">
          <ActionButton text={<i className="fa fa-upload" aria-hidden="true"></i>} active={true} onClick={uploadDocument} isLoading={loading} customClass="btn btn-primary" />
          <ActionButton text={<i className="fa fa-times" aria-hidden="true"></i>} active={true} onClick={clearFile} customClass='ml-3' isLoading={loading} />
        </div>
      )}
    </>;
  };

  return (
    <>
      {!!file ? getSelectedImageSlot() : <FileUploaderWithPDF onSelectFile={onSelectFile} onError={onError} />}
      {!!error && <Error message={error} />}
    </>
  );
};

export { DocumentUpload };